<template>
  <div>
    <v-dialog
      v-model="dialog"
      @click:outside="setDialog(false)"
      @keydown.esc="setDialog(false)"
      scrollable
      :persistent="innerLoading != false"
      max-width="95vw"
    >
      <v-row class="ma-0 pa-0">
        <v-col cols="8" class="pa-0 ma-0">
          <v-card rounded="0" height="100%">
            <v-toolbar
              :dark="leadPhase !== 'finished'"
              :ligth="leadPhase !== 'finished'"
              dense
              class="white--text"
              flat
              :color="colorToolBar"
              :class="
                `lead-phase-${leadPhase} lead-tracking-phase-${leadTrackingPhase} lead-operation-phase-${leadOperationPhase}`
              "
            >
              <v-toolbar-title class="font-weight-regular my-4"
                >Detalle del Lead
                <small v-if="isMultiOportunity"> (Multi-Oportunidad )</small>
                <!-- En caso de que sea el original de multi -->
                <small
                  v-else-if="
                    lead.contact_lead?.customer && lead.phase == 'finished'
                  "
                ></small>
                <small v-if="leadTrackingPhase === 'unassigned'">
                  (Sin asignar)</small
                >
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <lead-detail-menu-actions
                :page="page"
                @refresh="setDialog(false)"
              />
            </v-toolbar>
            <DuplicatedLeadBanner
              :lead="lead"
              @click="verLeadDuplicados()"
              @delete-duplicate="confirmDeleteDuplicate"
            />
            <div v-if="showMatchesButton" class="px-4 pt-2">
              <v-btn
                small
                depressed
                dark
                color="primary"
                @click="modalMatches = true"
              >
                <v-icon left small>mdi-account-multiple-outline</v-icon>
                Coincidencias
              </v-btn>
            </div>
            <BrexDataBanner
              v-if="!loading"
              ref="cardBrokerExternal"
              :external_broker="lead.external_broker"
              :show-card="lead.contact?.source?.name === 'Broker Externo'"
              @changeNewExternalBroker="
                id => sendUpdateOneField('contact_external_broker_id', id)
              "
            />
            <ToggleButton
              :options="[
                { label: 'Cliente Directo', value: 'lead' },
                { label: 'Broker Externo', value: 'external_broker' }
              ]"
              v-model="leadType"
              size="small"
              variant="outlined"
              full-width
            />
            <lead-transform-external-broker
              :show-dialog="leadType === 'external_broker'"
              :lead="lead"
              @refresh="setDialog(false)"
            />
            <v-card-text>
              <v-container>
                <!--input-editable-confirm prependIcon="mdi-home-search" /-->
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-skeleton-loader
                      :loading="loading"
                      height="50"
                      type="list-item"
                    >
                      <v-text-field
                        :disabled="!watchAndEdit"
                        dense
                        v-model="leadName"
                        label="Nombre"
                        aria-autocomplete="off"
                        :loading="innerLoading === 'name'"
                        @blur="sendUpdateOneField('name', leadName)"
                        class="my-3"
                      >
                        <template v-slot:prepend>
                          <v-icon>mdi-account</v-icon>
                        </template>
                      </v-text-field>
                    </v-skeleton-loader>
                  </v-col>
                  <v-col cols="12" sm="6" v-if="role !== 'developer'">
                    <v-skeleton-loader
                      :loading="loading"
                      height="50"
                      type="list-item"
                    >
                      <v-text-field
                        :disabled="!watchAndEdit"
                        dense
                        v-model="contactLeadEmail"
                        label="Correo"
                        aria-autocomplete="off"
                        :loading="innerLoading === 'contact_lead_email'"
                        @blur="
                          sendUpdateOneField(
                            'contact_lead_email',
                            contactLeadEmail
                          )
                        "
                        class="my-3"
                      >
                        <template v-slot:prepend>
                          <v-icon>mdi-email</v-icon>
                        </template>
                        <template v-slot:append v-if="contactLeadEmail">
                          <v-menu
                            open-on-hover
                            offset-y
                            left
                            close-delay="500"
                            open-delay="300"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon small v-bind="attrs" v-on="on">
                                mdi-dots-vertical
                              </v-icon>
                            </template>
                            <LeadContactActions
                              type="email"
                              :value="contactLeadEmail"
                              :lead-id="lead._id"
                              :contact-lead-id="lead.contact_lead_id"
                            />
                          </v-menu>
                        </template>
                      </v-text-field>
                    </v-skeleton-loader>
                  </v-col>
                  <v-col cols="12" sm="6" v-if="role !== 'developer'">
                    <v-skeleton-loader
                      :loading="loading"
                      height="50"
                      type="list-item"
                    >
                      <v-text-field
                        :disabled="!watchAndEdit"
                        dense
                        v-model="contactLeadPhone"
                        label="Teléfono"
                        aria-autocomplete="off"
                        :loading="innerLoading === 'contact_lead_phone'"
                        @blur="
                          sendUpdateOneField(
                            'contact_lead_phone',
                            formatPhone(contactLeadPhone)
                          )
                        "
                      >
                        <template v-slot:prepend>
                          <v-icon>mdi-phone</v-icon>
                        </template>
                        <template v-slot:append v-if="contactLeadPhone">
                          <v-menu
                            open-on-hover
                            offset-y
                            left
                            close-delay="500"
                            open-delay="300"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon small v-bind="attrs" v-on="on">
                                mdi-dots-vertical
                              </v-icon>
                            </template>
                            <LeadContactActions
                              type="phone"
                              :value="contactLeadPhone"
                              :lead-id="lead._id"
                              :contact-lead-id="lead.contact_lead_id"
                            />
                          </v-menu>
                        </template>
                      </v-text-field>
                    </v-skeleton-loader>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-skeleton-loader
                      :loading="loading"
                      height="50"
                      type="list-item"
                    >
                      <v-combobox
                        :value="contactLeadLocation"
                        @update:search-input="
                          val => (contactLeadLocation = val)
                        "
                        @blur="
                          sendUpdateOneField(
                            'contact_lead_location',
                            contactLeadLocation
                          )
                        "
                        :items="locations"
                        label="Ubicación"
                      ></v-combobox>
                    </v-skeleton-loader>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-skeleton-loader
                      :loading="loading"
                      height="50"
                      type="list-item"
                    >
                      <v-row
                        v-if="realEstateListAssigned && restrictedZones"
                        class="mx-1"
                      >
                        <v-icon>mdi-magnify</v-icon>

                        <SuperZones
                          :realEstateList="realEstateListAssigned"
                          @setZones="
                            value => sendUpdateOneField('zones', value)
                          "
                          :restrictedZones="true"
                          :defaultZone="lead.zones"
                        />
                      </v-row>
                      <div v-else-if="realEstateListAssigned">
                        <div
                          v-if="getTotalProperties(realEstateListAssigned) > 0"
                        >
                          <v-menu
                            bottom
                            :offset-y="true"
                            max-height="300"
                            :class="showMenuSelect ? 'menu-search' : ''"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                :disabled="!watchAndEdit"
                                dense
                                v-bind="attrs"
                                v-on="on"
                                :loading="innerLoading === 'zones'"
                                label="Interesado en:"
                                hint="Ciudad, desarrollos, zona, etc."
                                @input="
                                  filterRealEstateAssing(realEstateListAssigned)
                                "
                                @blur="
                                  sendUpdateOneField(
                                    'zones',
                                    leadInterestedZones
                                  )
                                "
                                @click="
                                  tmpRealEstateListAssigned = realEstateListAssigned
                                "
                                v-model="leadInterestedZones"
                                aria-autocomplete="off"
                              >
                                <template v-slot:prepend>
                                  <v-icon>mdi-magnify</v-icon>
                                </template></v-text-field
                              >
                            </template>

                            <v-list>
                              <v-list-item
                                v-if="tmpRealEstateListAssigned.length <= 0"
                              >
                                <v-btn block text>
                                  Sin coincidencias
                                  <v-spacer></v-spacer>
                                </v-btn>
                              </v-list-item>
                              <template v-else>
                                <v-list-item
                                  v-for="(item,
                                  index) in tmpRealEstateListAssigned"
                                  :key="index"
                                >
                                  <v-btn
                                    block
                                    text
                                    @click="
                                      selectedInterest(item),
                                        sendUpdateOneField(
                                          'zones',
                                          leadInterestedZones
                                        )
                                    "
                                  >
                                    {{ item.name }}
                                    <v-spacer></v-spacer>
                                  </v-btn>
                                </v-list-item>
                              </template>
                            </v-list>
                          </v-menu>
                        </div>
                        <div
                          v-else-if="
                            getTotalDevelops(realEstateListAssigned) > 0
                          "
                        >
                          <v-menu
                            bottom
                            :offset-y="true"
                            max-height="300"
                            :class="showMenuSelect ? 'menu-search' : ''"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                :disabled="!watchAndEdit"
                                dense
                                v-bind="attrs"
                                v-on="on"
                                label="Interesado en:"
                                :loading="innerLoading === 'zones'"
                                hint="Ciudad, desarrollos, zona, etc."
                                @input="
                                  filterRealEstateAssing(realEstateListAssigned)
                                "
                                @blur="
                                  sendUpdateOneField(
                                    'zones',
                                    leadInterestedZones
                                  )
                                "
                                @click="
                                  tmpRealEstateListAssigned = realEstateListAssigned
                                "
                                v-model="leadInterestedZones"
                                aria-autocomplete="off"
                              ></v-text-field>
                            </template>

                            <v-list>
                              <v-list-item
                                v-if="tmpRealEstateListAssigned.length <= 0"
                              >
                                <v-btn block text>
                                  Sin coincidencias
                                  <v-spacer></v-spacer>
                                </v-btn>
                              </v-list-item>
                              <template v-else>
                                <v-list-item
                                  v-for="(item,
                                  index) in tmpRealEstateListAssigned"
                                  :key="index"
                                >
                                  <v-btn
                                    block
                                    text
                                    @click="
                                      selectedInterest(item),
                                        sendUpdateOneField(
                                          'zones',
                                          leadInterestedZones
                                        )
                                    "
                                  >
                                    {{ item.name }}
                                    <v-spacer></v-spacer>
                                  </v-btn>
                                </v-list-item>
                              </template>
                            </v-list>
                          </v-menu>
                        </div>
                        <div v-else>
                          <v-text-field
                            :disabled="!watchAndEdit"
                            dense
                            aria-autocomplete="off"
                            v-model="leadInterestedZones"
                            label="Interesado en"
                            :loading="innerLoading === 'zones'"
                            @blur="
                              sendUpdateOneField('zones', leadInterestedZones)
                            "
                          >
                            <template v-slot:prepend>
                              <v-icon>mdi-home-search</v-icon>
                            </template>
                          </v-text-field>
                        </div>
                      </div>
                      <div v-else>
                        <v-text-field
                          :disabled="!watchAndEdit"
                          dense
                          aria-autocomplete="off"
                          v-model="leadInterestedZones"
                          label="Interesado en"
                          :loading="innerLoading === 'zones'"
                          @blur="
                            sendUpdateOneField('zones', leadInterestedZones)
                          "
                        >
                          <template v-slot:prepend>
                            <v-icon>mdi-home-search</v-icon>
                          </template>
                        </v-text-field>
                      </div>
                    </v-skeleton-loader>
                  </v-col>
                  <v-col cols="12" sm="6" class="ma-0 pa-0">
                    <v-col cols="12" class="ma-0 pa-2">
                      <v-row justify="center" align="center" class="">
                        <v-col cols="6">
                          <v-skeleton-loader
                            :loading="loading"
                            height="50"
                            type="list-item"
                          >
                            <v-row justify="start" align="start">
                              <v-col cols="2">
                                <div
                                  class="pa-2 blue lighten-5 rounded-circle d-inline-block"
                                >
                                  <v-img
                                    v-if="
                                      contactSource &&
                                        contactSource.media &&
                                        contactSource.media.src
                                    "
                                    contain
                                    :src="contactSource.media.src"
                                    width="20px"
                                    height="20px"
                                  >
                                  </v-img>
                                </div>
                              </v-col>
                              <v-col cols="10">
                                <div class="mx-2">
                                  <v-select
                                    :disabled="
                                      userRole === 'developer' ||
                                        userRole === 'marketing' ||
                                        userRole === 'marketingv2'
                                    "
                                    :value="contactSource"
                                    :items="sourcesList"
                                    item-text="name"
                                    return-object
                                  >
                                    <template v-slot:label>
                                      ¿Dónde se enteró?

                                      <!--  <v-tooltip
                                        max-width="300px"
                                        color="black"
                                        bottom
                                      >
                                        <template
                                          v-slot:activator="{ on, attrs }"
                                        >
                                          <v-icon
                                            v-bind="attrs"
                                            v-on="on"
                                            style="font-size: 22px; cursor: pointer;"
                                          >
                                            mdi-help-circle
                                          </v-icon>
                                        </template>

                                        <v-row class="pa-4">
                                          <v-col cols="12" class="ma-0 pa-0">
                                            ¿Dónde nos encontró?
                                          </v-col>
                                        </v-row>
                                      </v-tooltip> -->
                                    </template>
                                    <template v-slot:item="{ item, on }">
                                      <v-list-item
                                        v-on="on"
                                        @click="updateContactSource(item)"
                                      >
                                        <v-list-item-avatar>
                                          <div
                                            class="pa-2 blue lighten-5 rounded-circle d-inline-block"
                                          >
                                            <v-img
                                              v-if="item && item.media"
                                              contain
                                              :src="item.media.src"
                                              width="20px"
                                              height="20px"
                                            >
                                            </v-img>
                                          </div>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                          <v-list-item-title>
                                            <v-row no-gutters align="center">
                                              <div>{{ item.name }}</div>
                                            </v-row>
                                          </v-list-item-title>
                                        </v-list-item-content>
                                      </v-list-item>
                                    </template>
                                  </v-select>
                                </div>
                              </v-col>
                            </v-row>
                          </v-skeleton-loader>
                        </v-col>
                        <v-col cols="6">
                          <v-skeleton-loader
                            :loading="loading"
                            height="50"
                            type="list-item"
                          >
                            <v-row justify="start" align="start">
                              <v-col cols="2">
                                <div
                                  class="pa-2 blue lighten-5 rounded-circle d-inline-block"
                                >
                                  <v-img
                                    v-if="
                                      contactMedium &&
                                        contactMedium.media &&
                                        contactMedium.media.src
                                    "
                                    contain
                                    :src="contactMedium.media.src"
                                    width="20px"
                                    height="20px"
                                  >
                                  </v-img>
                                </div>
                              </v-col>
                              <v-col cols="10">
                                <div class="mx-2">
                                  <v-select
                                    :disabled="
                                      userRole === 'developer' ||
                                        userRole === 'marketing' ||
                                        userRole === 'marketingv2'
                                    "
                                    :value="contactMedium"
                                    :items="mediumsList"
                                    item-text="name"
                                    return-object
                                    label="Medio"
                                  >
                                    <template v-slot:label>
                                      ¿Cómo nos contactó?

                                      <!--      <v-tooltip
                                        max-width="300px"
                                        color="black"
                                        bottom
                                      >
                                        <template
                                          v-slot:activator="{ on, attrs }"
                                        >
                                          <v-icon
                                            v-bind="attrs"
                                            v-on="on"
                                            style="font-size: 22px; cursor: pointer;"
                                          >
                                            mdi-help-circle
                                          </v-icon>
                                        </template>

                                        <v-row class="pa-4">
                                          <v-col cols="12" class="ma-0 pa-0">
                                            ¿Cómo nos contactó?
                                          </v-col>
                                        </v-row>
                                      </v-tooltip> -->
                                    </template>
                                    <template v-slot:item="{ item, on }">
                                      <v-list-item
                                        v-on="on"
                                        @click="updateContactMedium(item)"
                                      >
                                        <v-list-item-avatar>
                                          <div
                                            class="pa-2 blue lighten-5 rounded-circle d-inline-block"
                                          >
                                            <v-img
                                              v-if="item && item.media"
                                              contain
                                              :src="item.media.src"
                                              width="20px"
                                              height="20px"
                                            >
                                            </v-img>
                                          </div>
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                          <v-list-item-title>
                                            <v-row no-gutters align="center">
                                              <div>{{ item.name }}</div>
                                            </v-row>
                                          </v-list-item-title>
                                        </v-list-item-content>
                                      </v-list-item>
                                    </template>
                                  </v-select>
                                </div>
                              </v-col>
                            </v-row>
                          </v-skeleton-loader>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-col>
                  <v-col cols="12" sm="8">
                    <v-skeleton-loader
                      :loading="loading"
                      height="50"
                      type="list-item"
                    >
                      <v-text-field
                        :disabled="!watchAndEdit"
                        dense
                        type="number"
                        aria-autocomplete="off"
                        v-model="leadBudget"
                        label="Presupuesto"
                        :loading="innerLoading === 'budget'"
                        @blur="
                          !leadBudget.includes('.')
                            ? sendUpdateOneField('budget', leadBudget)
                            : ''
                        "
                      >
                        <template v-slot:prepend>
                          <v-icon>mdi-currency-usd</v-icon>
                        </template>
                      </v-text-field>
                    </v-skeleton-loader>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-skeleton-loader :loading="loading" type="list-item">
                      <v-select
                        :disabled="!watchAndEdit"
                        v-model="leadCurrency"
                        :items="currency"
                        label="Moneda"
                        @input="leadCurrency = $event"
                        @change="leadCurrency = $event"
                        @blur="sendUpdateOneField('currency', leadCurrency)"
                        hide-details
                        prepend-icon="mdi-map"
                        single-line
                      ></v-select>
                    </v-skeleton-loader>
                  </v-col>
                  <v-col cols="10" class="pb-5 lead-input-field">
                    <v-skeleton-loader
                      :loading="loading"
                      height="50"
                      type="list-item-three-line"
                    >
                      <v-col cols="12">
                        <AdvancedObservation
                          v-model="leadObservations"
                          :editable="watchAndEdit"
                          @save="
                            () => {
                              sendUpdateOneField(
                                'observations_detail',
                                leadObservations
                              );
                            }
                          "
                        />
                      </v-col>
                      <v-row>
                        <v-col cols="6" v-if="lead.observations_detail?.link">
                          <v-text-field
                            :disabled="!watchAndEdit"
                            dense
                            filled
                            :value="lead.observations_detail?.link"
                            aria-autocomplete="off"
                            label="Enlace"
                            :loading="innerLoading === 'observations_detail'"
                          >
                            <template v-slot:prepend>
                              <v-icon>mdi-link-variant</v-icon>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="6"
                          v-if="lead.observations_detail?.contact_link"
                        >
                          <v-text-field
                            :disabled="!watchAndEdit"
                            dense
                            filled
                            :value="lead.observations_detail?.contact_link"
                            aria-autocomplete="off"
                            label="Enlace de Contacto"
                            :loading="innerLoading === 'observations_detail'"
                          >
                            <template v-slot:prepend>
                              <v-icon>mdi-link-variant</v-icon>
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-skeleton-loader>
                  </v-col>
                  <v-col cols="2" class="pa-0">
                    <div class="text-center">
                      <v-skeleton-loader
                        :loading="loading"
                        height="50"
                        type="avatar"
                      >
                        <v-menu
                          :disabled="!watchAndEdit"
                          class="py-8"
                          v-model="showProfileSelect"
                          absolute
                          :close-on-content-click="false"
                          :nudge-width="84"
                          :nudge-right="10"
                          :nudge-top="60"
                          offset-y
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-img
                              class="mt-3"
                              contain
                              height="48"
                              v-bind="attrs"
                              v-on="on"
                              :src="
                                !leadProfile && !hasEnterUpdateProfile
                                  ? emptyProfileImage
                                  : profileItems[slider].srcImage
                              "
                            ></v-img>
                          </template>
                          <!--  :thumb-color="profileItems[slider].color" -->
                          <v-slider
                            dense
                            vertical
                            v-model="slider"
                            thumb-size="24"
                            thumb-label="always"
                            min="0"
                            max="3"
                            @focus="hasEnterUpdateProfile = true"
                            @change="
                              () => {
                                sendUpdateOneField(
                                  'profile',
                                  profileItems[slider].value
                                );
                                showProfileSelect = false;
                              }
                            "
                          >
                            <template v-slot:thumb-label="{ value }">
                              <v-img
                                contain
                                :height="48"
                                :src="profileItems[value].srcImage"
                              />
                            </template>
                          </v-slider>
                        </v-menu>
                      </v-skeleton-loader>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" v-if="role === 'admin'">
                    <v-skeleton-loader
                      :loading="loading"
                      height="50"
                      type="list-item"
                    >
                      <select-contact-broker
                        :page="'leadDetail'"
                        @getOption="() => {}"
                      />
                    </v-skeleton-loader>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    v-if="
                      leadSlected !== 'unassigned_tracking' &&
                        leadPhaseStatus !== true
                    "
                  >
                    <v-skeleton-loader
                      v-if="lead.phase != 'discarded'"
                      :loading="loading"
                      height="50"
                      type="list-item"
                    >
                      <v-select
                        :disabled="!watchAndEdit"
                        v-if="lead.phase != 'discarded'"
                        ref="phaseLead"
                        label="Selecciona una fase"
                        item-disabled="disable"
                        :items="filters ? filters['phases'] ?? [] : []"
                        v-model="leadSlected"
                        @change="sendUpdateLeadPhase(leadSlected)"
                      >
                        <template v-slot:prepend>
                          <v-icon>mdi-filter</v-icon>
                        </template>
                        <template v-slot:selection="{ item, index }">
                          {{ item.text }}
                        </template>
                      </v-select>
                    </v-skeleton-loader>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-skeleton-loader
                      v-if="lead.contact"
                      :loading="loading"
                      height="50"
                      type="list-item"
                    >
                      <v-select
                        :value="lead.contact.language"
                        label="Idioma"
                        :items="['Español', 'Inglés']"
                        @change="updateLanguage"
                      >
                        <template v-slot:prepend>
                          <v-icon>mdi-translate</v-icon>
                        </template>
                      </v-select>
                    </v-skeleton-loader>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-skeleton-loader
                      v-if="filters?.categories?.length"
                      :loading="loading"
                      height="50"
                      type="list-item"
                    >
                      <LeadSelectCategory
                        :value="lead.category"
                        @input="updateCategory"
                        :categories="filters?.categories ?? []"
                        prepend-icon="mdi-tag"
                      />
                    </v-skeleton-loader>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    v-if="leadSlected !== 'unassigned_tracking'"
                  >
                    <v-skeleton-loader
                      :loading="loading"
                      height="50"
                      type="list-item"
                    >
                      <v-card width="200px" elevation="0">
                        <v-switch
                          :disabled="!watchAndEdit"
                          color="success"
                          v-model="leadPhaseStatus"
                          @change="
                            toggleEndPhase(leadPhase, $event !== null, $event)
                          "
                        >
                          <template v-slot:label>
                            <div>
                              {{
                                leadPhaseStatus === true
                                  ? "Comisión cobrada"
                                  : "Comisión cobrada"
                              }}
                            </div>
                          </template>
                        </v-switch>
                      </v-card>
                    </v-skeleton-loader>
                  </v-col>
                  <!-- Resume -->
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="6">
                        <v-skeleton-loader
                          :loading="loading"
                          height="30"
                          type="list-item"
                        >
                          <label class="font-weight-bold">ID:</label>
                          {{ lead._id }}
                          <IconCopyToClipBoard
                            size="small"
                            color="gray"
                            :text="lead._id"
                          />
                        </v-skeleton-loader>
                        <v-skeleton-loader
                          :loading="loading"
                          height="30"
                          type="list-item"
                        >
                          <label class="font-weight-bold"
                            >Fecha de registro:</label
                          >
                          {{ formatDate(lead.created_at) }}
                        </v-skeleton-loader>

                        <v-skeleton-loader
                          :loading="loading"
                          height="30"
                          type="list-item"
                          v-if="lead.zones"
                        >
                          <label class="font-weight-bold">Origen:</label>
                          {{ lead.zones }}
                        </v-skeleton-loader>
                      </v-col>
                      <v-col cols="6">
                        <v-skeleton-loader
                          :loading="loading"
                          height="30"
                          type="list-item"
                        >
                          <div>
                            <label class="font-weight-bold">Fuente:</label>

                            <img
                              class="mx-2"
                              :src="lead.contact?.source.media.src"
                              width="20px"
                              height="20px"
                            />
                            {{ lead.contact?.source.name }}
                          </div>
                          <div v-if="marketingEntries.length">
                            <div
                              v-for="([key, val], index) in marketingEntries"
                              :key="index"
                            >
                              <label class="font-weight-bold">{{ key }}:</label>
                              {{ val }}
                            </div>
                          </div>
                        </v-skeleton-loader>
                      </v-col>
                    </v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      v-if="lead.phase == 'discarded'"
                      class="grey lighten-4 rounded text-center"
                    >
                      <v-skeleton-loader
                        :loading="loading"
                        height="50"
                        type="list-item"
                      >
                        <label class="font-weight-bold"
                          >Motivo de descarte:</label
                        >
                        {{
                          lead.discard_observations
                            ? lead.discard_observations
                            : "No sé específico el motivo de descarte."
                        }}
                      </v-skeleton-loader>
                    </v-col>
                  </v-col>
                </v-row>
              </v-container>

              <v-skeleton-loader :loading="loading" height="94" type="card">
                <v-tabs v-model="tab" slider-color="primary">
                  <v-tab>
                    <v-icon left>mdi-comment-text-multiple</v-icon>
                    Comentarios
                  </v-tab>
                  <v-tab>
                    <v-icon left>mdi-account-clock</v-icon>
                    Asignaciones
                  </v-tab>
                  <!-- <v-tab>
                    <v-icon left>mdi-message-text-fast-outline</v-icon>
                    Respuestas genéricas
                  </v-tab> -->
                  <v-tab-item>
                    <lead-comments
                      :lead="lead"
                      :leadId="lead._id"
                      :lead-phase="lead.phase"
                      :lead-tracking-phase="lead.tracking_phase"
                      :lead-operation-phase="lead.operation_phase"
                      :comments="lead.comments"
                      :adminsComments="lead.comments_contact_admin"
                      :brokersComments="lead.comments_contact_broker"
                      :developersComments="lead.comments_contact_developer"
                      :srcBrokerImage="lead.internal_broker | brokerImageFormat"
                      :brokerName="brokerName"
                    />
                  </v-tab-item>
                  <v-tab-item>
                    <AssignmentHistory :lead="lead" :brokers="contactList" />
                  </v-tab-item>
                  <!-- <v-tab-item>
                    <lead-generic-responses
                      :lead-id="lead._id"
                      :visible="tab === 2"
                    />
                  </v-tab-item> -->
                </v-tabs>
              </v-skeleton-loader>
            </v-card-text>
          </v-card>
        </v-col>
        <!-- Aqui comienzan la parte de el perfilApp -->
        <v-col cols="4" class="pa-0 ma-0">
          <v-card height="100%" color="#fbf1fd" rounded="0">
            <v-toolbar
              :dark="leadPhase !== 'finished'"
              :ligth="leadPhase !== 'finished'"
              dense
              class="white--text"
              flat
              :class="
                `lead-phase-${leadPhase} lead-tracking-phase-${leadTrackingPhase} lead-operation-phase-${leadOperationPhase}`
              "
            >
              <v-toolbar-title class="font-weight-regular my-4"
                >Perfilación</v-toolbar-title
              >
              <v-spacer></v-spacer>
              <!-- <lead-detail-menu-actions /> -->
              <v-btn icon @click="setDialog(false)" id="close-lead-modal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-container>
              <LeadCallsTags
                :calls="lead.ringoverData"
                :no-response-count="lead.noResponseCount"
                :broker-name="brokerName"
                :has-assigned-broker="!!(lead && lead.contact_broker_id)"
              />
              <lead-detail-integration-actions
                v-if="!loading && lead"
                :lead="lead"
              />
              <CustomFieldsLeadSection :lead="lead" />

              <LeadPerfilApp />
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-dialog>
    <LeadMatchesModal
      v-if="lead && lead._id"
      :dialog.sync="modalMatches"
      :lead-id="lead._id"
      @linked="fetchActualLead(lead._id)"
    />
    <LeadDuplicatesModal
      :dialog="modalDuplicados"
      :lead="lead"
      :leadsDuplicados="leadsDuplicados"
      :innerLoading="!!innerLoading"
      @update:dialog="modalDuplicados = $event"
    />
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import LeadDuplicatesModal from "./components/LeadDuplicatesModal.vue";
import { GetContactLeadDuplicate } from "@/api/contacts-api.js";

export default {
  components: {
    // InputEditableConfirm: () => import("@/components/layout/inputs/InputEditableConfirm.vue"),
    LeadComments: () => import("@/components/lead/LeadComments.vue"),
    LeadPerfilApp: () => import("@/components/lead/LeadPerfilApp.vue"),
    LeadDetailMenuActions: () =>
      import("@/components/lead/LeadDetailMenuActions.vue"),
    SelectContactBroker: () =>
      import("@/components/contact-broker/SelectContactBroker.vue"),
    //LeadPostponeAction: () => import("@/components/lead/LeadPostpone.vue"),
    BrexDataBanner: () =>
      import("@/components/lead/components/brexDataBanner.vue"),
    LeadDuplicatesModal,
    LeadMatchesModal: () =>
      import("@/components/lead/components/LeadMatchesModal.vue"),
    IconCopyToClipBoard: () =>
      import("@/components/common/IconCopyToClipBoard.vue"),
    LeadContactActions: () =>
      import("@/components/lead/LeadContactActions.vue"),
    AdvancedObservation: () =>
      import("@/components/lead/components/advancedObservations/index.vue"),
    ToggleButton: () => import("@/components/common/toogle/index.vue"),
    LeadTransformExternalBroker: () =>
      import("@/components/lead/LeadTransformExternalBroker.vue"),
    CustomFieldsLeadSection: () =>
      import(
        "@/components/lead/components/customFields/CustomFieldsLeadSection.vue"
      ),
    LeadCallsTags: () =>
      import("@/components/lead/components/LeadCallsTags.vue"),
    SuperZones: () => import("@/components/lead/components/SuperZones.vue"),
    AssignmentHistory: () =>
      import("@/components/lead/components/assignmentHistory/index.vue"),
    DuplicatedLeadBanner: () =>
      import("@/components/lead/components/DuplicatedLeadBanner.vue"),
    LeadDetailIntegrationActions: () =>
      import("@/components/lead/components/LeadDetailIntegrationActions.vue"),
    LeadSelectCategory: () =>
      import("@/components/lead/components/LeadSelectCategory/index.vue")
    // LeadGenericResponses: () =>
    //   import("@/components/lead/LeadGenericResponses.vue")
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    page: {
      type: String,
      default: ""
    }
  },
  filters: {
    brokerImageFormat(broker) {
      if (!(broker && broker.name)) return "";
      let brokerSrcImg = "";
      let brokerName = "";
      if (broker.name) brokerName = broker.name;
      if (
        broker.media &&
        broker.media.featured_image &&
        broker.media.featured_image.src
      )
        brokerSrcImg = broker.media.featured_image.src;
      if (!brokerName) brokerName = "C28";
      if (!brokerSrcImg)
        brokerSrcImg =
          "https://dummyimage.com/400x200/262d3c/fff&text=" +
          brokerName.substring(0, 2);

      return brokerSrcImg;
    },
    mktFilter(mktString, param) {
      // comprobar que exista el string mkt
      if (!mktString) return " - ";
      let findParam = param;
      // solo el campo Campaña no tiene '|' al principio
      if (param !== "Campaña") findParam = `| ${param}`;
      // revisar que exista el parametro en el string mkt
      const index = mktString.indexOf(findParam);
      if (index < 0) return " - ";
      let startPos = index + param.length + 2;
      if (param !== "Campaña") startPos += 2; // aumentar otros 2 por separador '|'
      // encontrar el siguiente delimitador '|'
      const indexDelimiter =
        mktString.indexOf("|", startPos) > 0
          ? mktString.indexOf("|", startPos)
          : mktString.length;
      return mktString.substring(startPos, indexDelimiter).trim();
    }
  },
  data() {
    return {
      tab: null,
      leadType: "lead",
      slider: 0,
      role: localStorage.getItem("user_role"),
      showMenuSelect: false,
      // bandera que indica si abrió el panel para editar el termometro
      hasEnterUpdateProfile: false,
      publicPath: process.env.BASE_URL,
      innerLoading: false,
      userRole: localStorage.getItem("user_role") || "",
      showProfileSelect: false,
      emptyProfileImage: `${process.env.BASE_URL}vacio.png`,
      contactSelectedId: "",
      completeLeadSurvey: null,
      suggestedRealEstate: [],
      profileItems: [
        {
          value: "D",
          srcImage: `${process.env.BASE_URL}50azul.png`,
          color: "blue"
        },

        {
          value: "C",
          srcImage: `${process.env.BASE_URL}50amarillo.png`,
          color: "yellow"
        },
        {
          value: "B",
          srcImage: `${process.env.BASE_URL}50naranja.png`,
          color: "orange"
        },

        {
          value: "A",
          srcImage: `${process.env.BASE_URL}50rojo.png`,
          color: "red"
        }
      ],
      phaseSelected: {
        text: "Por Asignar",
        value: "unassigned",
        data: {
          phase: "active",
          tracking_phase: "unassigned",
          operation_phase: ""
        }
      },
      currency: ["MXN", "USD"],
      typeSelected: null,
      paySelected: null,
      objectiveSelected: null,
      searchingTime: null,
      optionsSaw: null,
      workingWith: null,
      deadlineTime: null,
      leadCurrency: null,
      tmpRealEstateListAssigned: [],
      phone: "",
      text: "Lorem ipsum dolor sit amet",
      modalDuplicados: false,
      modalMatches: false,
      locations: [],
      lastSearch: null,
      loadingLocations: false
    };
  },
  computed: {
    ...mapGetters({
      settings: "realEstateGroup/settings"
    }),
    // Coincidencias: solo con contact_grouping 'on' (si la config no está
    // disponible, p. ej. coordinator sin acceso al detalle, basta el lead)
    showMatchesButton() {
      const group = this.$store.state.realEstateGroup?.realEstateGroup;
      if (group && group.contact_grouping !== "on") return false;
      return !!(
        this.lead &&
        (this.lead.unified_contact_id || this.lead.contact_match)
      );
    },
    marketingEntries() {
      const marketing = this.lead?.miscellaneous?.marketing;
      if (!marketing) return [];
      return Object.entries(marketing);
    },
    ...mapState({
      realEstateAssigned: state =>
        state.realEstateDevelopments.realEstateAssign,
      loadingRealEstate: state =>
        state.realEstateDevelopments.loadingRealEstateAssign,
      loading: state => state.leads.loading,
      lead: state => state.leads.actualItem,
      leadSecondary: state => state.leads.secondaryItem,
      leadsDuplicados: state => state.leads.leadsDuplicados,
      realEstateListAssigned: state =>
        state.realEstateDevelopments.realEstateAssign,
      realEstateGroupLoading: state =>
        state.realEstateGroup.realEstateGroupLoading,
      filters: state => state.leads.filter.filters,
      contactList: state => state.contacts.contactList
    }),
    restrictedZones() {
      return this.settings?.restricted_zones || false;
    },
    colorToolBar() {
      if (this.lead.tracking_phase == "unassigned") return "#600202";
      if (this.lead.phase == "finished") return "";
      if (this.isMultiOportunity) return "";
      return "primary";
    },
    isMultiOportunity() {
      if (this.lead.hasOwnProperty("multi_sales_opportunities"))
        return this.lead.multi_sales_opportunities.length != 0;
      return false;
    },
    watchAndEdit() {
      if (this.role == "admin") return true;
      if (this.role == "broker") return true;
      return false;
    },
    leadName: {
      get() {
        if (this.lead && this.lead.contact_lead_name) {
          return this.lead.contact_lead_name;
        }
        return "";
      },
      set(newValue) {
        this.$store.commit("leads/updateActualLead", {
          leadId: this.lead._id,
          page: this.page,
          name: newValue,
          contact_lead_name: newValue
        });
      }
    },
    contactLeadEmail: {
      get() {
        if (this.lead && this.lead.contact_lead_email) {
          if (this.role === "marketing" || this.role === "marketingv2")
            return "";
          return this.lead.contact_lead_email;
        }
        return "";
      },
      set(newValue) {
        this.$store.commit("leads/updateActualLead", {
          leadId: this.lead._id,
          page: this.page,
          email: newValue,
          contact_lead_email: newValue
        });
      }
    },
    contactLeadPhone: {
      get() {
        if (this.lead && this.lead.contact_lead_phone) {
          if (this.role === "marketing" || this.role === "marketingv2")
            return "";
          return this.lead.contact_lead_phone;
        }
        return "";
      },
      set(newValue) {
        this.$store.commit("leads/updateActualLead", {
          leadId: this.lead._id,
          page: this.page,
          phone: newValue,
          contact_lead_phone: newValue
        });
      }
    },
    contactLeadLocation: {
      get() {
        if (this.lead && this.lead.contact_lead_location)
          return this.lead.contact_lead_location;
        return "";
      },
      set(newValue) {
        this.locations = [];
        this.$store.commit("leads/updateActualLead", {
          leadId: this.lead._id,
          page: this.page,
          location: newValue,
          contact_lead_location: newValue
        });
        this.setLocations(newValue);
      }
    },
    leadInterestedZones: {
      get() {
        if (this.lead && this.lead.zones) return this.lead.zones;
        return "";
      },
      set: function(newValue) {
        this.$store.commit("leads/updateActualLead", {
          leadId: this.lead._id,
          page: this.page,
          zones: newValue
        });
      }
    },
    leadBudget: {
      get() {
        if (this.lead && this.lead.budget) return this.lead.budget;
        return "";
      },
      set: function(newValue) {
        if (newValue.includes(".")) return;
        this.$store.commit("leads/updateActualLead", {
          leadId: this.lead._id,
          page: this.page,
          budget: newValue
        });
      }
    },
    leadObservations: {
      get() {
        if (
          this.lead &&
          this.lead.observations_detail &&
          this.lead.observations_detail.message
        ) {
          return this.lead.observations_detail.message;
        } else {
          return "";
        }
      },
      set: function(newValue) {
        this.$store.commit("leads/updateActualLead", {
          page: this.page,
          leadId: this.lead._id,
          observations_detail: {
            message: newValue,
            category:
              this.lead && this.lead.observations_detail
                ? this.lead.observations_detail.category
                : "",
            interested_unit:
              this.lead && this.lead.observations_detail
                ? this.lead.observations_detail.interested_unit
                : "",
            contact_link:
              this.lead && this.lead.observations_detail
                ? this.lead.observations_detail?.contact_link
                : "",
            link:
              this.lead && this.lead.observations_detail
                ? this.lead.observations_detail?.link
                : ""
          }
        });
      }
    },
    leadProfile: {
      get() {
        if (this.lead && this.lead.profile) return this.lead.profile;
        return "";
      },
      set: function(newValue) {
        this.$store.commit("leads/updateActualLead", {
          page: this.page,
          profile: newValue
        });
      }
    },
    leadPhase: {
      get() {
        if (this.lead && this.lead.phase) return this.lead.phase;
        return "";
      }
    },
    leadPhaseStatus: {
      get() {
        if (this.lead && this.lead.phase && this.lead.phase === "finished")
          return true;
        else return false;
      },
      set: function(newValue) {
        if (newValue) {
          this.$store.commit("leads/updateActualLead", {
            page: this.page,
            phase: "finished"
          });
        } else {
          this.$store.commit("leads/updateActualLead", {
            page: this.page,
            phase: "active"
          });
        }
      }
    },
    leadTrackingPhase: {
      get() {
        if (this.lead && this.lead.tracking_phase)
          return this.lead.tracking_phase;
        return "";
      }
    },
    leadOperationPhase: {
      get() {
        if (this.lead && this.lead.operation_phase)
          return this.lead.operation_phase;
        return "";
      }
    },
    brokerselected: {
      get() {
        if (this.lead && this.lead.internal_broker) {
          return this.lead.internal_broker._id;
        }
        if (this.lead && this.lead.internal_admin) {
          return this.lead.internal_admin._id;
        }
        return "";
      }
    },
    leadSlected: {
      get() {
        return this.phaseSelected;
      },
      set: function(newValue) {
        const _phase = this.filters["phases"].find(
          item => item.value === newValue
        );
        if (_phase) {
          this.phaseSelected = _phase;
          this.$store.commit("leads/updateActualLead", {
            leadId: this.lead._id,
            page: this.page,
            phase: _phase.data.phase,
            tracking_phase: _phase.data.tracking_phase,
            operation_phase: _phase.data.operation_phase
          });
        }
      }
    },
    leadgetMkt: {
      get() {
        if (this.lead && this.lead.miscellaneous) {
          return this.lead.miscellaneous.mkt;
        } else {
          return false;
        }
      }
    },
    brokerName() {
      try {
        return this.lead.internal_broker.name;
      } catch {
        return "";
      }
    },
    sourcesList() {
      return this.filters?.sources?.map(s => s.source) ?? [];
    },
    mediumsList() {
      return this.filters?.mediums?.map(m => m.medium) ?? [];
    },
    contactSource() {
      return this.lead.contact?.source;
    },
    contactMedium() {
      return this.lead.contact?.medium;
    }
  },
  watch: {
    leadProfile(newValue) {
      let profileNumber = 0;
      switch (newValue) {
        case "A":
          profileNumber = 3;
          break;
        case "B":
          profileNumber = 2;
          break;
        case "C":
          profileNumber = 1;
          break;
        case "D":
          profileNumber = 0;
          break;
        default:
          profileNumber = 0;
          break;
      }
      this.slider = profileNumber;
    },
    loading(newVal) {
      if (!newVal) {
        if (this.lead._id !== undefined) {
          if (this.lead.currency) {
            this.leadCurrency = this.lead.currency;
          } else {
            this.leadCurrency = "MXN";
          }
        } else {
          this.completeLeadSurvey = null;
          this.leadCurrency = "MXN";
        }
      } else {
        this.completeLeadSurvey = null;
        this.leadCurrency = "MXN";
      }
    },
    lead(newValue) {
      this.leadType = "lead";
      if (newValue.phase) this.findPhaseSelected();
    }
  },
  mounted() {
    this.tmpRealEstateListAssigned = this.realEstateListAssigned;
  },
  created() {
    // this.viewPhasesLeads = this.phasesLeads;
    this.tmpRealEstateListAssigned = this.realEstateListAssigned;
  },
  methods: {
    ...mapActions({
      fetchUpdatelLead: "leads/fetchUpdatelLead",
      updateLeadV2: "leads/updateLeadV2",
      fetchCompleteLeadSurveySt: "leads/fetchCompleteLeadSurvey",
      nextQuestionSt: "leads/nextQuestion",
      fetchActualLead: "leads/fetchActualLead",
      fetchLeadDuplicados: "leads/fetchLeadDuplicados",
      deleteLead: "leads/deleteLead"
    }),
    ...mapMutations({
      setLoading: "leads/setLoading"
    }),
    async confirmDeleteDuplicate(lead) {
      this.$confirmation(
        "Eliminar Lead",
        "Esta acción no se puede deshacer. ¿Estás seguro de que deseas eliminar este lead?",
        () => this.handleDeleteDuplicate(lead.leadId)
      );
    },
    async handleDeleteDuplicate(leadId) {
      try {
        const res = await this.deleteLead({ leadId });
        if (!res) throw new Error("Error deleting lead");
        this.$snotify.success("Lead eliminado correctamente", "Success");
        this.setDialog(false);
      } catch (error) {
        return this.$snotify.error(
          "Hubo un error al eliminar el Lead",
          "Error :|"
        );
      }
    },
    setLocations(val) {
      if (this.loadingLocations) return;
      if (!val || val == "null" || this.lastSearch == val) return;

      this.loadingLocations = true;

      // Lazily load input items
      fetch(
        `https://api.geocodify.com/v2/autocomplete?api_key=TcVFDtgWv1qr3xi6DNVdZOsMq7fAZHsW&q=${val}&lat=21.161908&lng=-86.8515279`
      )
        .then(res => res.json())
        .then(res => {
          const features = res.response?.features || [];
          this.locations = features.map(
            _location => _location.properties.label
          );
        })
        .catch(() => {
          this.locations = [];
        })
        .finally(() => {
          this.loadingLocations = false;
          this.lastSearch = val;
        });
    },
    formatDate(date) {
      if (!date) return "";
      const newDate = new Date(date);
      return newDate.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
      });
    },
    getBrokerselected(l) {
      if (l.internal_admin && l.internal_admin.name) {
        return l.internal_admin;
      } else if (l.internal_broker && l.internal_broker.name) {
        return l.internal_broker;
      } else {
        return { name: "Por asginar", role: "" };
      }
    },
    updateContactSource(item) {
      this.$store.commit("leads/updateActualLead", {
        leadId: this.lead._id,
        contact: {
          source: item
        }
      });
      this.sendUpdateOneField("contact", {
        source: item._id
      });
    },
    async updateContactMedium(item) {
      this.$store.commit("leads/updateActualLead", {
        leadId: this.lead._id,
        contact: {
          medium: item
        }
      });
      await this.sendUpdateOneField("contact", {
        medium: item._id
      });
    },
    getTotalProperties(list) {
      var totalProperties = 0;
      for (let i = 0; i < list.length; i++) {
        if (list[i].totalProperties > 0) {
          totalProperties = totalProperties + 1;
        }
      }
      return totalProperties;
    },
    getTotalDevelops(list) {
      return list.length;
    },
    selectedInterest(item) {
      if (item) {
        this.leadInterestedZones = item.name;
      }
      this.showMenuSelect = false;
    },
    filterRealEstateAssing(list) {
      const self = this;
      self.showMenuSelect = true;
      if (self.leadInterestedZones) {
        let tmpList = list.filter(e => {
          return e.name
            .toLowerCase()
            .includes(self.leadInterestedZones.toLowerCase());
        });
        self.tmpRealEstateListAssigned = tmpList;
      } else {
        self.tmpRealEstateListAssigned = list;
      }
    },
    getRealEstateAssignList() {
      let list = [];
      for (let i = 0; i < this.realEstateAssigned.length; i++) {
        list.push(this.realEstateAssigned[i].name);
      }
      this.suggestedRealEstate = list;
    },
    filterRealEstateAssignList() {
      if (this.leadInterestedZones) {
        let filterlist = this.realEstateAssigned.filter(r => {
          return r.name
            .toLowerCase()
            .includes(this.leadInterestedZones.toLowerCase());
        });
        let list = [];
        for (let i = 0; i < filterlist.length; i++) {
          list.push(filterlist[i].name);
        }
        this.suggestedRealEstate = list;
      } else {
        this.getRealEstateAssignList();
      }
    },
    getProfileImage(profile) {
      let image = "";
      switch (profile) {
        case "A":
          image = `${this.publicPath}50rojo.png`;
          break;
        case "B":
          image = `${this.publicPath}50naranja.png`;
          break;
        case "C":
          image = `${this.publicPath}50amarillo.png`;
          break;
        case "D":
          image = `${this.publicPath}50azul.png`;
          break;
        default:
          image = "";
          break;
      }
      return image;
    },
    getHowDidContactUsIcon(howDidContactUs) {
      if (howDidContactUs === undefined) return "mdi-information-outline";
      if (!howDidContactUs) return "mdi-information-outline";
      let icon = "";
      let image = false;
      let url = "";
      switch (howDidContactUs.toLowerCase()) {
        case undefined:
          icon = "mdi-help-circle";
          url = "";
          image = false;
          break;
        case null:
          icon = "mdi-help-circle";
          url = "";
          image = false;
          break;
        case "":
          icon = "mdi-help-circle";
          url = "";
          image = false;
          break;
        case "google":
          icon = "mdi-google";
          url = "";
          image = false;
          break;
        case "facebook":
          icon = "mdi-facebook";
          url = "";
          image = false;
          break;
        case "instragram":
          icon = "mdi-instragram";
          url = "";
          image = false;
          break;
        case "whatsapp":
          icon = "mdi-whatsapp";
          url = "";
          image = false;
          break;
        case "walkin":
          icon = "mdi-walk";
          url = "";
          image = false;
          break;
        case "llamada":
          icon = "mdi-phone";
          url = "";
          image = false;
          break;
        case "lona / tapial":
          icon = "mdi-vector-rectangle";
          url = "";
          image = false;
          break;
        case "referido":
          icon = "mdi-account-multiple";
          url = "";
          image = false;
          break;
        case "inmuebles24":
          icon = "mdi-sofa";
          url = "";
          image = false;
          break;
        case "revista":
          icon = "mdi-book-open-page-variant-outline";
          url = "";
          image = false;
          break;
        case "eventos":
          icon = "glass-wine";
          url = "";
          image = false;
          break;
        case "caseta":
          icon = "mdi-store-outline";
          url = "";
          image = false;
          break;
        case "vivaanuncios":
          icon = "mdi-vimeo";
          url = "";
          image = false;
          break;
        case "lamudi":
          icon = "mdi-home";
          url = "";
          image = false;
          break;
        case "broker externo":
          icon = "mdi-comment-multiple";
          url = "";
          image = false;
          break;
        case "youtube":
          icon = "mdi-chart-youtube";
          url = "";
          image = false;
          break;
        case "crm":
          icon = "mdi-chart-bar";
          url = "";
          image = false;
          break;
        case "linkedin":
          icon = "mdi-linkedin";
          url = "";
          image = false;
          break;
        case "mercadolibre":
          icon = "mdi-charity";
          url = "";
          image = false;
          break;
        case "easybroker":
          icon = "mdi-charity";
          url = "https://www.easybroker.com/brand_files/icon.png";
          image = true;
          break;
        case "prospección":
          icon = "mdi-account-supervisor-circle-outline";
          url = "";
          image = false;
          break;
        case "otro":
          icon = "mdi-help-circle";
          url = "";
          image = false;
          break;
        default:
          icon = "mdi-information-outline";
          url = "";
          image = false;
          break;
      }
      return {
        isImage: image,
        icon: icon,
        url: url
      };
    },
    formatPhone(phone) {
      if (phone) {
        return phone.includes("+")
          ? `+${phone.replace(/\D/g, "")}`
          : phone.replace(/\D/g, "");
      } else {
        return "";
      }
    },
    async sendUpdateOneField(field, value) {
      if (field === "tracking_phase" || field === "operation_phase") {
        this.innerLoading = field;
        setTimeout(() => {
          let updateData = {
            leadId: this.lead._id,
            contactLeadId: this.lead.contact_lead_id,
            lead: {}
          };
          updateData.lead["phase"] =
            field === "tracking_phase" ? "active" : "in-operation";
          updateData.lead[field] = value;
          this.sendUpdateLead(updateData);
        }, 250);
      } else if (field === "currency") {
        this.$store.commit("leads/updateActualLead", {
          leadId: this.lead._id,
          page: this.page,
          currency: value
        });
        this.innerLoading = field;
        setTimeout(() => {
          let updateData = {
            leadId: this.lead._id,
            contactLeadId: this.lead.contact_lead_id,
            lead: {}
          };
          updateData.lead[field] = value;
          this.sendUpdateLead(updateData);
        }, 250);
      } else if (field === "observations_detail") {
        this.innerLoading = field;
        setTimeout(() => {
          let updateData = {
            leadId: this.lead._id,
            contactLeadId: this.lead.contact_lead_id,
            lead: {}
          };
          updateData.lead[field] = {
            message: value,
            category:
              this.lead && this.lead.observations_detail
                ? this.lead.observations_detail.category
                : "",
            interested_unit:
              this.lead && this.lead.observations_detail
                ? this.lead.observations_detail.interested_unit
                : "",
            contact_link:
              this.lead && this.lead.observations_detail
                ? this.lead.observations_detail?.contact_link
                : "",
            link:
              this.lead && this.lead.observations_detail
                ? this.lead.observations_detail?.link
                : ""
          };
          this.sendUpdateLead(updateData);
        }, 250);
      } else if (field === "budget") {
        const cleanBudget = value.trim() === "" ? 0 : value;

        const sameValue = this.inputsWithSameValue(field, cleanBudget);
        if (sameValue) return;
        this.innerLoading = field;

        let updateData = {
          leadId: this.lead._id,
          contactLeadId: this.lead.contact_lead_id,
          lead: {}
        };

        updateData.lead[field] = cleanBudget;

        this.sendUpdateLead(updateData);
      } else if (field === "profile") {
        this.innerLoading = field;
        setTimeout(() => {
          let updateData = {
            leadId: this.lead._id,
            contactLeadId: this.lead.contact_lead_id,
            lead: {}
          };
          this.leadProfile = value;
          updateData.lead[field] = value;
          this.sendUpdateLead(updateData);
        }, 250);
      } else if (
        field === "contact_lead_email" ||
        field === "contact_lead_phone"
      ) {
        if (this.inputsWithSameValue(field, value)) return;

        if (!value) {
          this.innerLoading = field;
          let updateData = {
            leadId: this.lead._id,
            contactLeadId: this.lead.contact_lead_id,
            lead: {}
          };
          updateData.lead[field] = value;
          this.sendUpdateLead(updateData);
          return;
        }

        this.innerLoading = field;
        try {
          const duplicateParams =
            field === "contact_lead_email"
              ? { email: value }
              : { phone: value };
          duplicateParams.contact_lead_id = this.lead.contact_lead_id;
          const response = await GetContactLeadDuplicate(duplicateParams);
          if (response.results > 0) {
            this.innerLoading = false;
            this.revertContactField(field);
            this.$snotify.warning(
              field === "contact_lead_email"
                ? "Este correo ya está registrado en otro lead."
                : "Este teléfono ya está registrado en otro lead.",
              "Duplicado detectado",
              {
                closeOnClick: true,
                titleMaxLength: 30,
                timeout: 4000
              }
            );
            return;
          }
        } catch (err) {
          // Si falla la verificación de duplicados, no bloqueamos la actualización
        }

        let updateData = {
          leadId: this.lead._id,
          contactLeadId: this.lead.contact_lead_id,
          lead: {}
        };
        updateData.lead[field] = value;
        this.sendUpdateLead(updateData);
      } else {
        //Validamos si los inputs que estan mandando son del mismo valor
        if (!this.inputsWithSameValue(field, value)) {
          this.innerLoading = field;

          let updateData = {
            leadId: this.lead._id,
            contactLeadId: this.lead.contact_lead_id,
            lead: {}
          };
          updateData.lead[field] = value;
          this.sendUpdateLead(updateData);
        }
      }
    },
    revertContactField(field) {
      const previousValue =
        field === "contact_lead_email"
          ? this.leadSecondary.contact_lead_email
          : this.leadSecondary.contact_lead_phone;
      this.$store.commit("leads/updateActualLead", {
        leadId: this.lead._id,
        page: this.page,
        [field === "contact_lead_email" ? "email" : "phone"]: previousValue,
        [field]: previousValue
      });
    },
    inputsWithSameValue(field, value) {
      if (
        field === "name" ||
        field === "contact_lead_email" ||
        field === "contact_lead_phone" ||
        field === "contact_lead_location" ||
        field === "budget" ||
        field === "contact"
      ) {
        if (field === "budget" && this.leadSecondary.budget === value)
          return true;

        if (this.leadSecondary.contact_lead_email === value) {
          return true;
        } else if (this.leadSecondary.contact_lead_phone === value) {
          return true;
        } else if (this.leadSecondary.contact_lead_name === value) {
          return true;
        } else if (this.leadSecondary.contact_lead_location === value) {
          return true;
        } else if (this.leadSecondary.contact?.medium._id === value.medium) {
          return true;
        } else if (this.leadSecondary.contact?.source._id === value.source) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    sendNotificationAssignBroker(contactBrokerId, nameAssignBroker) {
      this.innerLoading = contactBrokerId;
      setTimeout(() => {
        let updateData = {
          leadId: this.lead._id,
          contactLeadId: this.lead.contact_lead_id,
          zones: this.lead.zones,
          lead: {
            contactBrokerId,
            nameAssignBroker,
            assinedPhase: this.lead.tracking_phase
          }
        };
        this.sendUpdateLead(updateData);
      }, 250);
    },
    sendUpdateLead(updateData) {
      let self = this;
      self
        .fetchUpdatelLead(updateData)
        .catch(() => {
          self.$snotify.error(
            "Error!!!",
            `Ocurrio un problema actualizar el lead.`,
            {
              closeOnClick: true,
              timeout: 4000
            }
          );
        })
        .finally(async () => {
          self.setLoading(false);
          setTimeout(() => {
            self.innerLoading = false;
          }, 1000);
          const data2 = await this.fetchActualLead(this.lead._id);
          // Se hace este parseo para que cuando mute el lead, no cambie el secundario
          let data = JSON.parse(JSON.stringify(data2));
          this.$store.commit("leads/setSecondaryLead", data);
        });
    },
    sendUpdateLeadPhase(value) {
      if (value) {
        let updateData = {
          leadId: this.lead._id,
          contactLeadId: this.lead.contact_lead._id,
          lead: {
            phase: value.data.phase,
            tracking_phase: value.data.tracking_phase,
            operation_phase: value.data.operation_phase
          }
        };
        let self = this;
        self
          .fetchUpdatelLead(updateData)
          .then(() => {
            this.phaseSelected = value;
          })
          .catch(() => {
            self.$snotify.error(
              "Error!!!",
              `Ocurrio un problema actualizar el lead.`,
              {
                closeOnClick: true,
                timeout: 4000
              }
            );
          })
          .finally(async () => {
            self.setLoading(false);
            setTimeout(() => {
              self.innerLoading = false;
            }, 1000);
            const data2 = await this.fetchActualLead(this.lead._id);
            // Se hace este parseo para que cuando mute el lead, no cambie el secundario
            let data = JSON.parse(JSON.stringify(data2));
            this.$store.commit("leads/setSecondaryLead", data);
          });
      }
    },
    /* modal actions */
    // muestra u oculta el modal
    setDialog(show) {
      this.$emit("setDialog", show);
    },
    getContactBrokerOption(option) {
      if (option) {
        this.$store.commit("leads/updateActualLead", {
          leadId: this.lead._id,
          internal_broker: option
        });
        this.sendNotificationAssignBroker(option._id, option.name);
      }
    },
    toggleEndPhase(index, value, event) {
      if (index === "finished" && event === true) {
        this.sendUpdateOneField("phase", index);
      } else {
        this.sendUpdateOneField("phase", "active");
      }
    },
    async verLeadDuplicados() {
      if (this.role !== "admin") return;
      await this.fetchLeadDuplicados(this.lead._id);
      this.modalDuplicados = true;
    },
    async updateLead(data) {
      try {
        await this.updateLeadV2({
          leadId: this.lead._id,
          dataLead: data
        });
        return this.$snotify.success(
          `Se actualizo el lead correctamente.`,
          "Exito!!!"
        );
      } catch (error) {
        return this.$snotify.error(
          `Ocurrio un problema actualizar el lead.`,
          "Error!!!"
        );
      }
    },
    updateLanguage(language) {
      const data = { language };
      this.updateLead({ contact: data });
    },
    updateCategory(category) {
      if (category === this.lead.category?._id) return;
      this.updateLead({ category });
    },
    findPhaseSelected() {
      const _listPhases = this.filters["phases"];
      const _phaseSelected = _listPhases.find(phase => {
        return phase
          ? phase.data.phase === this.lead.phase &&
              phase.data.tracking_phase === this.lead.tracking_phase &&
              phase.data.operation_phase === this.lead.operation_phase
          : undefined;
      });
      this.phaseSelected = _phaseSelected ?? {
        text: "Por Asignar",
        value: "unassigned",
        data: {
          phase: "active",
          tracking_phase: "unassigned",
          operation_phase: ""
        }
      };
    }
  }
};
</script>
<style>
.caption-font {
  font-size: 12px;
  text-transform: none;
}
.loading-layer {
  min-height: 300px;
}
.v-menu__content.menuable__content__active {
  background-color: #f5f5f5;
  padding: 14px 0;
}
.v-slider__thumb-label.primary {
  background-color: transparent !important;
}
.v-toolbar.lead-phase-active {
  background-color: #424242;
}
.v-toolbar.lead-phase-active.lead-tracking-phase-unassigned {
  background-color: #671717;
}
.v-toolbar.lead-phase-in-operation {
  background-color: #172367;
}
.v-toolbar.lead-phase-finished {
  background-color: #fffbe8;
  color: rgb(104, 100, 100) !important;
}
.v-toolbar.lead-phase-discarded {
  background-color: #757575;
}
.v-text-field {
  padding-top: 0px !important;
}
.custom-placeholer-color input::placeholder {
  color: black !important;
  opacity: 1;
}

.custom-label-color .v-label {
  color: black;
  opacity: 1;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: transparent !important;
}
.text-info-duplicado {
  color: white !important;
}
</style>
